/**
 * Tab registry for the users admin page. Pure module (no React) so the
 * inductee/back-office classification and the URL-param fallback are
 * unit-testable on their own.
 */
import { hasStaffRole } from '@hcc/types';

export const USER_TABS = ['staff', 'inductees'] as const;

export type UserTabId = (typeof USER_TABS)[number];

export const USER_TAB_LABELS: Record<UserTabId, string> = {
  staff: 'Back office',
  // Inductees and training learners alike: anyone with only self-service
  // roles. The tab id stays 'inductees' so bookmarked ?tab= links keep working.
  inductees: 'Self-service',
};

/**
 * Self-service accounts (auto-provisioned inductees and training learners)
 * belong on the non-staff tab. Anything with a staff role - including
 * mixed-role users - is back office; role-less users (none assigned yet)
 * stay on the staff tab as "awaiting role assignment".
 */
export function isInducteeUser(roles: readonly string[]): boolean {
  return roles.length > 0 && !hasStaffRole(roles);
}

/** Map the raw ?tab= query param onto a tab; unknown values land on staff. */
export function resolveTab(param: string | null): UserTabId {
  if (param && (USER_TABS as readonly string[]).includes(param)) {
    return param as UserTabId;
  }
  return 'staff';
}
